// Rascunho local de carrinho por mesa (rota do garçom + painel CriarPedidos),
// pra recuperar itens selecionados quando o pedido não chega a ser enviado
// (app fechado, conexão caiu, etc). Usa localStorage (sobrevive a fechar o
// app/navegador) e um mapa por cod_org/cod_mesa, já que várias mesas podem
// ter um rascunho pendente ao mesmo tempo no mesmo dispositivo.

const STORAGE_KEY = 'rascunhos_pedidos';
const TTL_MS = 24 * 60 * 60 * 1000; // 24h

function lerTodos() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function gravarTodos(dados) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(dados));
}

export function salvarRascunhoMesa(cod_org, cod_mesa, itens) {
  if (!cod_org || !cod_mesa) return;

  if (!itens || itens.length === 0) {
    limparRascunhoMesa(cod_org, cod_mesa);
    return;
  }

  const dados = lerTodos();
  if (!dados[cod_org]) dados[cod_org] = {};
  dados[cod_org][cod_mesa] = { itens, salvo_em: Date.now() };
  gravarTodos(dados);
}

export function obterRascunhoMesa(cod_org, cod_mesa) {
  if (!cod_org || !cod_mesa) return null;

  const dados = lerTodos();
  const rascunho = dados[cod_org]?.[cod_mesa];
  if (!rascunho) return null;

  if (Date.now() - rascunho.salvo_em > TTL_MS) {
    limparRascunhoMesa(cod_org, cod_mesa);
    return null;
  }

  return rascunho.itens;
}

export function limparRascunhoMesa(cod_org, cod_mesa) {
  if (!cod_org || !cod_mesa) return;

  const dados = lerTodos();
  if (dados[cod_org]) {
    delete dados[cod_org][cod_mesa];
    if (Object.keys(dados[cod_org]).length === 0) {
      delete dados[cod_org];
    }
  }
  gravarTodos(dados);
}

export function limparTodosRascunhos() {
  localStorage.removeItem(STORAGE_KEY);
}
